import { createAsyncThunk } from '@reduxjs/toolkit';
import ScenarioApi from 'api/ScenariosAPI';
import { PublicScenario } from 'models/publicScenario';

export const fetchAllPublicScenario = createAsyncThunk<PublicScenario[]>(
  'publicScenario/fetchAll',
  async () => ScenarioApi.getScenariosPublic()
);
